import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { HomeProjectSection } from './HomeProjectSection.js';
import { makeSearchURL, convertToApiURL, searchTimeout } from './searchRequestUtils.js';
import { shuffleAndTruncate } from './arrayUtils.js';
import { getBaseLocationParams, NYCCountyNames } from './locationUtils.js';
import { hasMatch } from './projectUtils.js';
import {
    createChallengeSearchAPIURL,
    createSchoolSearchAPIURL,
    createTeacherSearchAPIURL,
} from '../search/searchApi.js';
import { isElementInViewport } from '../utils/visibleInViewport.js';

/* global getURLParam */ // defined in dc/general/queryParams.js
/* global readCookie */ // defined in dc/general/cookies.js
/* global dcAnalytics */ // defined in dc/general/dcAnalytics.js
/* global Uri */ // define in uri/URI.js

export const SuggestedProjectsSection = createReactClass({

    propTypes: {
        projectIdsToExclude: PropTypes.array,
        projectPageProjectId: PropTypes.number,
        showGiveWidget: PropTypes.bool,
        prepopulatedDonationAmountForGiveWidget: PropTypes.number,
        giveWidgetSubmitTakesUserDirectlyToCart: PropTypes.bool,
        minProjectsToShow: PropTypes.number,
        locationSearchCity: PropTypes.string,
        locationSearchCounty: PropTypes.string,
        locationSearchState: PropTypes.string,
        onScrollElementId: PropTypes.string,
        intendedSearchParams: PropTypes.object,
        useDefaults: PropTypes.bool,
        showHistorical: PropTypes.bool,
        seeMoreText: PropTypes.string,
        callbackWhenNotEnoughProjects: PropTypes.func,
        altViewForFullyFundedProjects: PropTypes.bool,
    },

    MAX_PROJECTS: 3,
    MAX_PAGE_RESULTS: 10,
    DEFAULT_SEARCH_URL: baseURL + 'donors/search.html',

    getInitialState: function () {
        return {
            suggestedProjects: {},
            description: '',
            suggestedProjectsSearchURL: '',
            retriedSuggestedProjectsSearch: false,
            renderSuggestedProjects: false,
            moreResultsUrl: '',
            seeMoreText: '',
        };
    },

    componentDidMount: function () {
        if (this.props.onScrollElementId) {
            this.attachListenersForProjectSuggestions();
        } else {
            this.initSuggestedProjects();
        }
    },

    initSuggestedProjects: function () {
        if (this.props.useDefaults) {
            this.loadDefaultProjects();
            return;
        } else if (this.props.intendedSearchParams) {
            const intendedSearchURL = makeSearchURL(this.props.intendedSearchParams, this.DEFAULT_SEARCH_URL);
            const intendedSearchApiURL = convertToApiURL(intendedSearchURL, this.MAX_PAGE_RESULTS, this.MAX_PAGE_RESULTS);
            this.setState({
                retriedSuggestedProjectsSearch: true,
                renderSuggestedProjects: true,
                moreResultsUrl: intendedSearchURL,
                seeMoreText: this.props.seeMoreText || 'See more similar projects',
            });
            this.loadSuggestedProjects(intendedSearchApiURL);
            return;
        }

        var searchTermsURLCookie = readCookie('searchTermsURL');
        var searchTermsDescriptionCookie = window.atob(readCookie('searchTermsDesc'));
        var searchTerm = searchTermsURLCookie ? searchTermsURLCookie.substring(searchTermsURLCookie.lastIndexOf('/') + 1, searchTermsURLCookie.indexOf('.html')) : undefined;
        var suggestedProjectsSearchURL, description, moreResultsUrl;

        switch (searchTerm) {
        case 'search':
            suggestedProjectsSearchURL = convertToApiURL(searchTermsURLCookie, this.MAX_PAGE_RESULTS, this.getMaxResults(searchTermsURLCookie));
            description = 'Other projects matching your search';
            this.loadLastSearchProjects(suggestedProjectsSearchURL, description, searchTermsURLCookie);
            break;
        case 'school': {
            const schoolId = getURLParam(searchTermsURLCookie, 'school');
            suggestedProjectsSearchURL = createSchoolSearchAPIURL(schoolId);
            description = 'Other projects at ' + searchTermsDescriptionCookie;
            moreResultsUrl = new Uri(this.DEFAULT_SEARCH_URL).addQueryParam('school', schoolId);
            this.loadLastSearchProjects(suggestedProjectsSearchURL, description, moreResultsUrl);
            break;
        }
        case 'viewChallenge': {
            const challengeId = getURLParam(searchTermsURLCookie, 'id');
            suggestedProjectsSearchURL = createChallengeSearchAPIURL('common/json_challenge.html', challengeId, undefined, undefined, 0, 10);
            description = 'Other projects supported by ' + searchTermsDescriptionCookie;
            moreResultsUrl = new Uri(this.DEFAULT_SEARCH_URL).addQueryParam('challengeId', challengeId);
            this.loadLastSearchProjects(suggestedProjectsSearchURL, description, moreResultsUrl);
            break;
        }
        case 'teacher': {
            const teacherId = getURLParam(searchTermsURLCookie, 'teacher');
            suggestedProjectsSearchURL = createTeacherSearchAPIURL(teacherId);
            description = 'Other projects from ' + searchTermsDescriptionCookie;
            moreResultsUrl = new Uri(this.DEFAULT_SEARCH_URL).addQueryParam('teacher', teacherId);
            this.loadLastSearchProjects(suggestedProjectsSearchURL, description, moreResultsUrl);
            break;
        }
        default:
            this.loadFallbackProjects();
        }
    },

    attachListenersForProjectSuggestions: function () {
        var component = this;
        if (this.props.onScrollElementId) {
            if (window.isiPad) { // end of momentum scrolling is hard to detect, so load suggested projects by default
                setTimeout(function () {
                    component.initSuggestedProjects();
                }, 500);
            } else {
                component.initScrollHandler();
            }
        } else {
            component.initSuggestedProjects();
        }
    },

    initScrollHandler: function () {
        var component = this;
        var onScrollElement = document.getElementById(component.props.onScrollElementId); var scrollTimer = null;

        $(window).on('DOMContentLoaded.loadSuggestedProjectsEvent load.loadSuggestedProjectsEvent resize.loadSuggestedProjectsEvent scroll.loadSuggestedProjectsEvent', function () {
            if (scrollTimer) {
                clearTimeout(scrollTimer); // clear any previous pending timer
            }
            scrollTimer = setTimeout(handleScroll, 100); // set new timer
        });

        function handleScroll() {
            scrollTimer = null;
            if (isElementInViewport(onScrollElement, true)) {
                component.initSuggestedProjects();
                $(window).off('.loadSuggestedProjectsEvent');
            }
        }
    },

    loadSuggestedProjects: function (url) {
        if (!url) {
            return;
        }

        if (this.getSuggestedProjects()) { // already loaded
            return;
        }

        $.ajax({
            type: 'get',
            url: url,
            cache: true,
            dataType: 'json',
            timeout: searchTimeout(),
            success: this.handleProjectResponse,
            error: function (xhr, status, message) {
                // It seems like we can get false positives of parsererror
                if (status !== 'parsererror') {
                    this.addProjectData([]);
                }
            }.bind(this),
        });
    },

    handleProjectResponse: function (data) {
        var projectsToShow = this.filterProjectResponses(data.proposals);

        if (projectsToShow.length < this.props.minProjectsToShow) {
            if (!this.state.retriedSuggestedProjectsSearch) {
                this.loadFallbackProjects();
            } else {
                this.setState({
                    renderSuggestedProjects: false,
                });
                if (this.props.callbackWhenNotEnoughProjects) {
                    this.props.callbackWhenNotEnoughProjects()
                }
            }
        } else {
            this.addProjectData(projectsToShow);
        }
    },

    filterProjectResponses(projects) {
        var props = this.props;
        var filteredProjects = projects.filter(function (project) {
            if (props.projectIdsToExclude && props.projectIdsToExclude.includes(parseInt(project.id))) {
                return false;
            }

            // in the edge case where we were searching for historical projects
            if (props.showHistorical && project.fundingStatus === 'funded') {
                return true;
            }

            // just in case updateIndex is lagging
            return project.fundingStatus === 'needs funding';
        });

        return filteredProjects;
    },

    loadLastSearchProjects: function (url, description, moreResultsUrl) {
        this.setState({
            suggestedProjectsSearchURL: url,
            renderSuggestedProjects: true,
            description: description,
            moreResultsUrl: moreResultsUrl,
            seeMoreText: this.props.seeMoreText ||'See more similar projects',
        });
        this.loadSuggestedProjects(url);
    },

    loadFallbackProjects: function () {
        const fallbackSearchURL = this.getFallbackSearchURL();
        const fallbackSearchAPIURL = convertToApiURL(fallbackSearchURL, this.MAX_PAGE_RESULTS, this.MAX_PAGE_RESULTS);
        this.setState({
            retriedSuggestedProjectsSearch: true,
            renderSuggestedProjects: true,
            description: this.props.locationSearchCity && this.props.locationSearchState ? 'Other projects near ' + this.props.locationSearchCity + ', ' + this.props.locationSearchState : 'Other projects you might like',
            moreResultsUrl: fallbackSearchURL,
            seeMoreText: this.props.seeMoreText ||'See more similar projects',
        });
        this.loadSuggestedProjects(fallbackSearchAPIURL);
    },

    loadDefaultProjects: function () {
        const searchAPIURL = convertToApiURL(this.DEFAULT_SEARCH_URL, this.MAX_PAGE_RESULTS, this.MAX_PAGE_RESULTS);
        this.setState({
            retriedSuggestedProjectsSearch: true,
            renderSuggestedProjects: true,
            description: "Thousands of teachers' projects would benefit from a donation of any size",
            moreResultsUrl: this.DEFAULT_SEARCH_URL,
            seeMoreText: this.props.seeMoreText ||'See all projects',
        });
        this.loadSuggestedProjects(searchAPIURL);
    },

    getFallbackSearchURL: function () {
        if (this.props.locationSearchCity && this.props.locationSearchState) {
            const params = getBaseLocationParams();
            params.state = this.props.locationSearchState;
            if (this.props.locationSearchCounty && this.props.locationSearchState === 'NY' && Object.values(NYCCountyNames).includes(this.props.locationSearchCounty)) {
                params.countyName = this.props.locationSearchCounty + 'county';
            } else {
                params.cityName = this.props.locationSearchCity;
            }
            return makeSearchURL(params, this.DEFAULT_SEARCH_URL);
        } else {
            return this.DEFAULT_SEARCH_URL;
        }
    },

    addProjectData: function (data) {
        var newData = $.extend({}, this.state.suggestedProjects);
        newData.result = shuffleAndTruncate(data, this.MAX_PROJECTS);
        this.setState({
            suggestedProjects: newData,
        }, this.trackDCAnalyticsOnRecommendationsLoad);
    },

    getSuggestedProjects: function () {
        return this.state.suggestedProjects.result;
    },

    getMaxResults: function (url) {
        return getURLParam(url, 'max') ? 0 : 10;
    },

    trackDCAnalyticsOnRecommendationsLoad: function () {
        const suggestedProjects = this.getSuggestedProjects();
        dcAnalytics.track('Project recommendations loaded', {
            projectPageId: this.props.projectPageProjectId,
            numRecs: suggestedProjects.length,
            numRecsWithMatchOffer: suggestedProjects.filter(el => hasMatch(el)).length,
            lastPageViewd: readCookie('lastVisitedPage'),
            urlUsedForRecs: this.state.suggestedProjectsSearchURL,
            invokedFallback: this.state.retriedSuggestedProjectsSearch,
        });
    },

    trackDCAnalyticsOnProjectCardClick: function (projectId) {
        dcAnalytics.track('Project recommendation clicked', {
            projectPageId: this.props.projectPageProjectId,
            projectRecommendationId: projectId,
        });
    },

    renderHomeProjectSection() {
        if (this.state.renderSuggestedProjects) {
            const suggestedProjects = this.getSuggestedProjects();
            return (
                <HomeProjectSection
                    searchURL={this.state.moreResultsUrl}
                    description={suggestedProjects ? this.state.description : ''}
                    seeMoreText={this.state.seeMoreText}
                    className="projects-suggested"
                    projects={suggestedProjects}
                    showGiveWidget={this.props.showGiveWidget}
                    prepopulatedDonationAmountForGiveWidget={this.props.prepopulatedDonationAmountForGiveWidget}
                    giveWidgetSubmitTakesUserDirectlyToCart={this.props.giveWidgetSubmitTakesUserDirectlyToCart}
                    onProjectCardClick={this.trackDCAnalyticsOnProjectCardClick}
                    altViewForFullyFundedProjects={this.props.altViewForFullyFundedProjects}
                />
            );
        }
    },

    render: function () {
        return (
            <div>
                {this.renderHomeProjectSection()}
            </div>
        );
    },

});
